import { AlphaACircleIcon } from './AlphaACircleIcon';

/**
 * author: Contributors
 * id 71A79E36-29B9-4543-B386-399F950641E2
 * name alpha-a-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-a-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetACircleIcon = AlphaACircleIcon;
export default AlphabetACircleIcon